import React from 'react'
import { Component } from 'react'
import { Container } from 'semantic-ui-react'
import { Icon } from 'semantic-ui-react'
import { CircularProgress } from '@mui/material'

const cargando = ()=>{
    return(
        <div>
        <Container className='dashcontent'>
        <div>
        <CircularProgress />
        <h2>Cargando...</h2>
        </div>
        </Container>
        </div>
    );
}

const privateContent = ()=>{
    return(
        <div>
        <Container className='dashcontent'>
        <div>
            <h2>No tienes permisos, suficientes para ver esta Interfaz!</h2>
            <Icon name='lock' size='massive' />
            <h3>Nuestros Ingenieros están siendo informados de la incidencia, si sigues presentando este error, y consideras que tienes permisos suficientes para ver este contenido, no dudes en contactarnos.</h3>
        </div>
        </Container>
        </div>
    )
}
//const BlockInterface = ({props, permissions,...rest}) => {
export default class BlockInterface extends Component {
    render(){
        // console.log(this.props.permissions)
        switch (this.props.permissions) {
            case false:
                // console.log('No tiene permisos..')
                // console.log(this.props.permissions)
                return (
                    privateContent()
                )
            case null:
                // console.log('Null..')
                // console.log(this.props.permissions)
                return (
                    cargando()
                    )
            default:
                // console.log('Cargando..')
                // console.log(this.props.permissions)
                return (
                    cargando()
                    )
             
        }
        
    }
}

//export default BlockInterface